module.exports = __webpack_public_path__ + "static/media/qm.5f971ea0.svg";